<template>
  <div
    :class="[
      'wrapper',
      {
        'desktop-hidden-sidebar':
          desktopHideSidebar || menuMode == 'prestitosi',
        'mobile-show-sidebar': mobileShowSidebar || menuMode == 'prestitosi',
      },
    ]"
  >
    <AppMenu
      v-if="menuMode == 'sidebar'"
      :model="menu"
      @menuitem-click="onMenuItemClick"
      @menu-toggle="onMenuToggle"
    />

    <AppTopbar
      v-if="menuMode == 'sidebar'"
      :model="menu"
      @menu-toggle="onMenuToggle"
      :showHamburger="showHamburger"
    />

    <AppPrestitosiTopbar
      v-if="menuMode == 'prestitosi'"
      :model="menu"
      @menu-toggle="onMenuToggle"
      :showHamburger="showHamburger"
    ></AppPrestitosiTopbar>

    <div
      class="content"
      :class="menuMode == 'prestitosi' ? 'content-prestitosi' : ''"
    >
      <div class="router-view">
        <router-view :key="$route.name"></router-view>
      </div>
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppTopbar from "./AppTopbar";
import AppPrestitosiTopbar from "./AppPrestitosiTopbar.vue";
import AppMenu from "./AppMenu.vue";
import AppFooter from "./AppFooter";
// import { mapGetters } from "vuex";
import AxiosService from "@/axiosServices/AxiosService";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useSessionTimeout } from "@/composables/useSessionTimeout";
import { useAssistenteIA } from "@/composables/useAssistenteIA";
import { useAiContext } from "@/composables/useAiContext";
import { infoPagina } from "@/utils/aiPagine";

export default {
  service: null,
  name: "App",
  components: {
    AppMenu,
    AppTopbar,
    AppFooter,
    AppPrestitosiTopbar,
  },
  setup() {
    // Burbuja del asistente IA (solo con sesión iniciada). El widget calcula la ruta,
    // los IDs y la pestaña; aquí se añaden los nombres de página y el tipo de producto.
    const statoPagina = useAiContext();
    useAssistenteIA({
      pages: infoPagina,
      getContext: () => ({ tipoProdotto: statoPagina.tipoProdotto }),
    });
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      desktopHideSidebar: 0,
      mobileShowSidebar: 0,
      menu: [],
      menuMode: "sidebar",
    };
  },
  created() {
    const store = useStore();
    const router = useRouter();
    
    // Inicializar control de sesión por inactividad (60 minutos)
    const sessionTimeout = useSessionTimeout(60);
    // 0.0833 minutos = 5 segundos para testing rápido
    sessionTimeout.startMonitoring();

    if (!store.getters["loggedUser"].livelloLogin) {
      router.push("/setloginlevel");
    }

    const CURRENT_URL = window.location.href;

    if (CURRENT_URL.includes("prestitosi-gest")) {
      this.menuMode = "prestitosi";
      this.service = new AxiosService();
      this.service
        .readCustomEndpoint(
          "https://prestitosi-core.datarete.cloud/api/GetMainMenu/G"
        )
        .then((res) => {
          if (res) {
            res.menu.forEach((item) => {
              item.items.forEach((subitem) => {
                if (subitem.to.includes("https")) {
                  subitem.command = () => {
                    window.open(subitem.to2, "_blank");
                  };
                  delete subitem.to;
                  delete subitem.items;
                }
              });
            });
            this.menu = res.menu;
          }
        });
    } else if (CURRENT_URL.includes("prestitosi-automotive")) {
      this.menuMode = "prestitosi";
      this.service = new AxiosService();
      this.service
        .readCustomEndpoint(
          "https://prestitosi-core.datarete.cloud/api/GetMainMenu/A"
        )
        .then((res) => {
          if (res) {
            res.menu.forEach((item) => {
              item.items.forEach((subitem) => {
                if (subitem.to.includes("https")) {
                  subitem.command = () => {
                    window.open(subitem.to2, "_blank");
                  };
                  delete subitem.to;
                  delete subitem.items;
                }
              });
            });
            this.menu = res.menu;
          }
        });
    } else {
      this.menuMode = "sidebar"; // CORRECT ONE
      // this.menuMode = "prestitosi"; //  TESTING GESIONALE
      this.service = new AxiosService();
      this.service
        .readCustomEndpoint(
          "https://prestitosi-core.datarete.cloud/api/GetMainMenu/C"
        )
        .then((res) => {
          if (res) {
            res.menu.forEach((item) => {
              item.items.forEach((subitem) => {
                if (subitem.to.includes("https")) {
                  subitem.command = () => {
                    window.open(subitem.to2, "_blank");
                  };
                  delete subitem.to;
                  delete subitem.items;
                }
              });
            });
            this.menu = res.menu;
          }
        });
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  methods: {
    onMenuToggle() {
      if (this.isDesktop) {
        this.desktopHideSidebar = !this.desktopHideSidebar;
      } else {
        this.mobileShowSidebar = !this.mobileShowSidebar;
      }
    },
    onMenuItemClick() {
      if (!this.isDesktop) {
        this.mobileShowSidebar = !this.mobileShowSidebar;
      }
    },
  },
  computed: {
    isDesktop() {
      return this.windowWidth > 991;
    },
    showHamburger() {
      if (this.isDesktop) {
        return this.desktopHideSidebar;
      } else {
        //return !this.mobileShowSidebar;
        return 1;
      }
    },
    // ...mapGetters(["menu"]),
  },
};
</script>
